export default "__VITE_ASSET__8bdddc8e__"